var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"position":"fixed","top":"0px","left":"0px","right":"0px","bottom":"0px","border":"none","width":"100%","height":"100%","z-index":"1000"},attrs:{"allowpaymentrequest":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }